import { Navigate, Outlet } from "react-router-dom";
import { hasValidAuthSession } from "../helpers/authSession";
import Constant from "../util/constant";

const ProtectedAdminRoute = () => {
  const role = window.localStorage.getItem("role");
  const allowed =
    hasValidAuthSession() && role === Constant.ROLES.ADMIN;

  return allowed ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedAdminRoute;
